import React from "react";
import styles from "./HelpCenter.module.scss";
import { useNavigate } from "react-router-dom";
import { CircleHelp, GraduationCap, Rocket } from "lucide-react";
import { MdSupportAgent } from "react-icons/md";

import Badge from "@Components/Badge";
import { useNewReleaseNotes } from "@Hooks/useNewReleaseNotes";

const HelpCenter: React.FC = () => {
  const navigate = useNavigate();
  const { hasNewReleaseNotes } = useNewReleaseNotes();

  const handleNavigateToFAQ = () => navigate("/faq");
  const handleNavigateToFeedback = () => navigate("/feedback");
  const handleNavigateToTutorials = () => navigate("/tutorials");
  const handleNavigateToContactUs = () => navigate("/contact-us");
  const handleNavigateToReleaseNotes = () => navigate("/release-notes");
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Help Center</h2>

      <div className={styles.helpCenter}>
        <div className={styles.flexbox}>
          <div className={styles.box}>
            <div className={styles.iconContainer}>
              <Rocket size={65} color="#EFF4FF" />
            </div>
            <div className={styles.card}>
              <h3 className={styles.cardTitle}>
                Release notes
                {hasNewReleaseNotes && (
                  <span className={styles.cardTitleBadge}>
                    <Badge badgeCount={1} />
                  </span>
                )}
              </h3>
              <p>
                Stay updated with the latest features, improvements, and bug
                fixes in our app.
              </p>

              <button
                className={styles.button}
                onClick={handleNavigateToReleaseNotes}
              >
                View all
              </button>
            </div>
          </div>
          {/* <div className={styles.box}>
            <div className={styles.iconContainer}>
              <GraduationCap size={65} color="#EFF4FF" />
            </div>
            <div className={styles.card}>
              <h3>Tutorials</h3>
              <p>
                Step-by-step guides to help you get the most out of our features
                and tools.
              </p>
              <button
                className={styles.button}
                onClick={handleNavigateToTutorials}
              >
                View all
              </button>
            </div>
          </div> */}
          {/* <div className={styles.box}>
            <div className={styles.iconContainer}>
              <CircleHelp size={65} color="#EFF4FF" />
            </div>
            <div className={styles.card}>
              <h3>FAQ</h3>
              <p>Find quick answers to the most commonly asked questions.</p>
              <button className={styles.button} onClick={handleNavigateToFAQ}>
                View all
              </button>
            </div>
          </div> */}
          <div className={styles.box}>
            <div className={styles.iconContainer}>
              <MdSupportAgent size={65} color="#EFF4FF" />
            </div>
            <div className={styles.card}>
              <h3>Support</h3>
              <p>Need help? Reach out to our support team for assistance.</p>
              <div className={styles.supportButtons}>
                <button
                  className={styles.button}
                  onClick={handleNavigateToContactUs}
                >
                  Contact us
                </button>
                <button
                  className={styles.button}
                  onClick={handleNavigateToFeedback}
                >
                  Feedback & Feature Request
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpCenter;
